import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import { isNetworkAccess, type NetworkAccess } from '../utilities/nodeAccess'

/**
 * A network's access, Org or Private (you and org admins): `networks.access` (router migration
 * 0219, PERMISSIONS.md § 4.1, D-20). Every member of the network's org reads it.
 *
 * ⚠ Its own select, never a column of `useNetwork.get()`: a database without the column fails this
 * read alone, and the network list stays whole. null: no network, not read yet, or not known.
 *
 * The setter lets a page show the value a change wrote (the router's answer) without a second read.
 */
export function useNetworkAccess(networkId: string | null | undefined) {
  const [access, setAccess] = useState<NetworkAccess | null>(null)

  useEffect(() => {
    let live = true
    setAccess(null)
    if (!networkId) return
    void (async () => {
      const { data, error } = await supabase.from('networks').select('access').eq('id', networkId).maybeSingle()
      if (!live) return
      if (error) console.warn('networks.access', error)
      setAccess(isNetworkAccess(data?.access) ? data.access : null)
    })()
    return () => {
      live = false
    }
  }, [networkId])

  return [access, setAccess] as const
}
